import { slugify } from "utils/url";

export class NavigationService {
  // Base paths
  private static readonly ADMIN_BASE = '/admin';

  public static getHomePath(): string {
    return '/home';
  }

  public static getArtistDetailsPath(id: string, name?: string): string {
    if (name) {
      return `/admin/artist/${slugify(name)}/${id}`;
    } else {
      return `/admin/artist/${id}`;
    }
  }

  public static getArtistsPath(): string {
    return '/artists';
  }

  public static getAuthLoginPath(): string {
    return '/auth/login';
  }

  public static getUserProfilePath(): string {
    return '/profile';
  }

  public static getUserOrdersPath(): string {
    return '/orders';
  }

  public static getUserSettingsPath(): string {
    return '/settings';
  }

  public static getItemDetailsPath(id: string, name?: string, isDemoted?: boolean): string {
    let basePath: string;
    if (name) {
      basePath = `/admin/item/${slugify(name)}/${id}`;
    } else {
      basePath = `/admin/item/${id}`;
    }

    if (isDemoted) {
      return `${basePath}?type=demoted`;
    }

    return basePath;
  }

  public static getListingDetailsPath(
    id: string,
    name?: string,
    isDemoted?: boolean
  ): string {
    const basePath = name
      ? `${this.ADMIN_BASE}/listing/${slugify(name)}/${id}`
      : `${this.ADMIN_BASE}/listing/${id}`;

    if (isDemoted) {
      return `${basePath}?type=demoted`;
    }

    return basePath;
  }

  public static getGroupingDetailsPath(id: string): string {
    return `${this.ADMIN_BASE}/groupings/details/${id}`;
  }

  public static getGroupingOverviewPath(): string {
    return `${this.ADMIN_BASE}/groupings/all`;
  }

  public static getGroupingCreatePath(): string {
    return `${this.ADMIN_BASE}/groupings/create`;
  }

  public static getScrapejobDetailsPath(id: string): string {
    return `${this.ADMIN_BASE}/scrapejobs/details/${id}`;
  }

  public static getScrapejobOverviewPath(): string {
    return `${this.ADMIN_BASE}/scrapejobs/all`;
  }

  public static getMergeDetailsPath(id: string): string {
    return `${this.ADMIN_BASE}/merges/details/${id}`;
  }

  public static getMergeOverviewPath(): string {
    return `${this.ADMIN_BASE}/merges/all`;
  }

  public static getMergeCreatePath(): string {
    return `${this.ADMIN_BASE}/merges/create`;
  }

  public static getDashboardPath(): string {
    return `${this.ADMIN_BASE}/dashboards/default`;
  }

  public static getExplorePath(): string {
    return `${this.ADMIN_BASE}/explore`;
  }

  public static getOrderDetailsPath(id: string): string {
    return `/order/${id}`;
  }

  public static getItemSearchPath(): string {
    return '/item/search';
  }

  public static getItemSuggestionPath(): string {
    return '/item/suggest';
  }

  public static getPortfolioDetailsPath(id: string): string {
    return `${this.ADMIN_BASE}/portfolio/${id}`;
  }

  public static getWishlistDetailsPath(id: string): string {
    return `${this.ADMIN_BASE}/wishlist/${id}`;
  }

  public static getTradingFloorPath(): string {
    return `${this.ADMIN_BASE}/trading-floor`;
  }

}
